/* eslint-disable */
import Header from "components/Common/Header/Header";
import CompanyScheduleBody from "components/CompaniesComponents/CompanyDetails/CompanySchedule/ScheduleBody/CompanyScheduleBody";
import React, { useEffect } from "react";

const CompanySchedule = () => {
  // -------- for title ------------
  useEffect(() => {
    document.title = "Clinic Schedule";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="companies" />

      {/* ------ body section --------- */}
      <CompanyScheduleBody />
    </main>
  );
};

export default CompanySchedule;
